module.exports = __webpack_public_path__ + "static/media/TWO.52fc8180.png";